import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Pagination } from '@shared/models/pagination.model';
import { SignedUrlObject } from '@shared/models/signedUrlObject.model';
import { BaseService } from '@shared/services/base.service';
import { Observable } from 'rxjs';

import {
  StockCheckHistoryListContent,
  StockCheckHistorySearchCriteria,
  StockCheckHistoryViewDetailResponse,
  StockCheckHistoryViewResponse
} from '../model/stock-check-history.model';

@Injectable({
  providedIn: 'root'
})
export class StockCheckHistoryService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.stockCheckHistory;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  getStockCheckHistoryList(criteria: StockCheckHistorySearchCriteria) {
    const params = this.getParams(criteria);
    const url = this.getFullUrlWithStoreNo(this.envService.list);
    console.log(url);
    return this.http.get<Pagination<StockCheckHistoryListContent>>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body',
      params
    });
  }

  getStockCheckHistoryView(recallNo: string) {
    const url = this.getFullUrlWithStoreNo(this.envService.view, { recallNo });

    return this.http.get<StockCheckHistoryViewResponse>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }
  getStockCheckHistoryViewDetail(recallNo: string, articleNo: string) {
    const url = this.getFullUrlWithStoreNo(this.envService.detail, { recallNo, articleNo });

    return this.http.get<StockCheckHistoryViewDetailResponse>(url, {
      headers: this.loaderHeaders(null),
      observe: 'body'
    });
  }

  override getFileUrl(refId: string): Observable<SignedUrlObject> {
    const url = this.getFullUrlWithStoreNo(this.envService.fileUrl);
    return this.http.post<SignedUrlObject>(url, { refId }, { headers: this.headers });
  }
}
